<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3 v-if="!haveItems">Você não possui promoções ativas</h3>
            <h3 v-if="haveItems">
              Você possui {{ numPromocoes }} promoções ativas
            </h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="inserirPromocao"
            >
              <i class="fa fa-plus fa-xl"></i>
              Adicionar promoção
            </b-button>
            <b-button
              variant="primary"
              class="my-2 my-sm-0 w100 mr5"
              type="submit"
              @click="atualizarJornalzinho"
            >
              <i class="fa fa-edit"></i>
              Vincular Jornalzinho
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="text-center f-g" v-if="!haveItems">
      <i class="fa fa-frown-o fa-custom-size"></i>
      <h4>Desculpe, não encontramos nenhuma promoção :(</h4>
      <h5>Para iniciar, clique no botão acima e comece as integrações!</h5>
    </b-card>
    <b-card class="text-center mt-3" v-if="haveItems" style="font-size: 15px">
      <b-table
        :items="items"
        :fields="fields"
        striped
        bordered
        hover
        @row-clicked="rowHandler"
        class="mb-0"
      >
        <template v-slot:cell(urlimagem)="data">
          <img
            v-if="data.item.urlimagem"
            :src="data.item.urlimagem"
            alt="Thumbnail"
            style="height: 100px"
          />
          <span v-else>Sem imagem</span>
        </template>
        <template v-slot:cell(isdestaque)="data">
          <div class="fa-2x">
            <i v-if="data.item.isjornalzinho == 1" class="fa fa-star"></i>
            <i
              v-else-if="data.item.isdestaque == 1"
              class="fa fa-star"
            ></i>
            <i v-else class="fa fa-star-o"></i>
          </div>
        </template>
        <template v-slot:cell(isjornalzinho)="data">
          <i v-if="data.item.isjornalzinho == 1" class="fa fa-check fa-lg"></i>
          <i v-else class="fa fa-times fa-lg"></i>
        </template>

        <template v-slot:cell(showText)="data">
          <b-badge v-if="data.item.showText == false" variant="danger" style="font-size: 15px">
            {{ data.item.showText == false ? "Não" : "Sim" }}
          </b-badge>
          <b-badge v-else variant="success">
            {{ data.item.showText == false ? "Não" : "Sim" }}
          </b-badge>
        </template>
      </b-table>
    </b-card>

    <b-modal
      ref="modalEditaPromocao"
      size="lg"
      centered
      hide-footer
      :title="titlePromocaoModal"
    >
      <b-row>
        <b-col cols="4" @click="destacarProdutos">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-star-o fa-custom-size" aria-hidden="true"></i>
            <span>
              Destacar
              <br />Produtos
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="editarImagem(urlImagemSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-file-image-o fa-custom-size" aria-hidden="true"></i>
            <span v-if="!urlImagemSelecionada">
              Vincular
              <br />Imagem
            </span>
            <span v-if="urlImagemSelecionada">
              Editar
              <br />Imagem
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="reenviarCampanha(idPromocaoSelecionada)">
          <b-col cols="12" class="centerModal">
            <i
              class="fa fa-share-square-o fa-custom-size"
              aria-hidden="true"
            ></i>
            <span>
              Reenviar
              <br />Campanha
            </span>
          </b-col>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4" @click="editarPromocao(idPromocaoSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-edit fa-custom-size" aria-hidden="true"></i>
            <span>
              Editar
              <br />promoção
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="desvincularPromocao(idPromocaoSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-times fa-custom-size" aria-hidden="true"></i>
            <span>
              Desvincular
              <br />promoção
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="atualizarItensPromocao(idPromocaoSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-refresh fa-custom-size" aria-hidden="true"></i>
            <span>
              Atualizar
              <br />itens
            </span>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "promocoes",
  components: {
    Loading,
  },
  data: function () {
    return {
      titlePromocaoModal: "",
      idPromocaoSelecionada: null,
      urlImagemSelecionada: null,
      promocaoDestacada: null,
      isLoading: false,
      temPromocoes: false,
      numPromocoes: 0,
      items: [],
      fields: [
        { key: "urlimagem", label: "Imagem" },
        { key: "isdestaque", label: "Destaque" },
        "titulo",
        "descricao",
        { key: "data_inicial", label: "Início", sortable: true },
        { key: "data_final", label: "Fim", sortable: true },
        { key: "isjornalzinho", label: "Jornalzinho" },
        { key: "showText", label: "Exibe Título e Descrição no App" },
      ],
      haveItems: false,
      IsJornalzinho: null,
      id_local: null,
      isdestaque: false,
      showText: false,
    };
  },
  methods: {
    inserirPromocao() {
      localStorage.setItem("jornalzinho", "0");
      this.$router.push("promocoes/inserir-promocao");
    },
    async destacaPromocao() {
      this.isLoading = true;
      const url = `${config.default.servidor}/gerencial/promocao/completa/destaque`;

      try {
        const response = await axios({
          url,
          method: "post",
          data: {
            id: this.idPromocaoSelecionada,
            destaque: this.isdestaque ? 1 : 0,
          },
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          await this.procurarPromocoes();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.$alert("Falha ao atualizar promoções","Erro","error");
          this.$refs.modalEditaPromocao.hide();
        }

      } catch (error) {
        console.log({error});
      }
    },

    destacarProdutos() {
      var currentVersion = parseInt(localStorage.getItem("app_version"));
      if (currentVersion === 13) this.destacaPromocao();
      else this.$router.push("promocoes/destaques");
    },

    atualizarJornalzinho() {
      localStorage.setItem("jornalzinho", "1");
      this.$router.push("promocoes/inserir-promocao");
    },

    reenviarCampanha(id) {
      localStorage.setItem("id", id);
      localStorage.setItem("isPromocao", "true");
      this.$router.push("reenviar-campanha");
    },

    rowHandler(record) {
      localStorage.setItem("promocaoSelecionada", JSON.stringify(record));
      this.id_local = record.id_local;
      this.titlePromocaoModal = `${record.titulo}`;
      this.idPromocaoSelecionada = record.id;
      this.urlImagemSelecionada = record.urlimagem;
      this.isdestaque = record.isdestaque;
      this.showText = record.showText;
      if (record.isdestaque == 1) {
        this.promocaoDestacada = true;
      } else {
        this.promocaoDestacada = false;
      }
      if (record.isjornalzinho == 1) {
        this.IsJornalzinho = true;
      } else {
        this.IsJornalzinho = false;
      }
      this.$refs.modalEditaPromocao.show();
    },
    async atualizarItensPromocao(id) {
      this.$refs.modalEditaPromocao.hide();
      this.isLoading = true;

      const url = `${config.default.servidor}/gerencial/promocao/itens`;

      try {
        const response = await axios({
          url,
          method: "post",
          data: {
            empresaid: localStorage.getItem("enterprise_id"),
            promocaoid: this.id_local,
            promocaowebid: id,
          },
          headers: { authorization: `${config.default.authorizationBasic}` },
        });
        if (!response.data.error) {
          this.$alert("Itens atualizados!", "Sucesso", "success");
        } else {
          this.$alert("Falha ao atualizar os itens!", "Erro", "error");
        }

        this.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async editarImagem(url) {
      localStorage.setItem("url_imagem", url);
      localStorage.setItem("titulo_promocao", this.titlePromocaoModal);
      localStorage.setItem("id_promocao", this.idPromocaoSelecionada);
      if (this.IsJornalzinho)
        await this.$router.push({
          path: "promocoes/editar-imagem-jornalzinho",
        });
      else await this.$router.push({ path: "promocoes/editar-imagem" });
    },

    async deletePromocao(id) {
      const url = `${config.default.servidor}/gerencial/promocao/${id}`;
      try {
        const response = await axios({
          url,
          method: "delete",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          this.$alert("A promoção foi desvinculada!", "Sucesso", "success");
          this.procurarPromocoes();
        }
      } catch (error) {
        this.$alert("Erro ao desvincular a promoção!", "Erro", "error");
      }
    },

    desvincularPromocao(id) {
      this.$refs.modalEditaPromocao.hide();

      this.$swal({
        title: "Promoção",
        text: "Confirma desvincular esta promoção do app?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((res) => {
        if (res.value) {
          this.deletePromocao(id);
        }
      });
    },

    async procurarPromocoes() {
      this.isLoading = true;

      const url = `${
        config.default.servidor
      }/gerencial/promocao/ativa/${localStorage
        .getItem("enterprise_id")
        .toString()}/${localStorage.getItem("app_version")}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.data.data.length > 0) {
          this.showText = response.data.show;
          this.items = response.data.data;
          this.numPromocoes = this.items.length;
          this.haveItems = true;
          this.isdestaque = response.data.data.isdestaque;
        } else {
          this.haveItems = false;
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        await this.$alert("Falha ao alterar a promoção!", "Erro", "error");
        console.error(error);
      }
    },

    editarPromocao(id) {
      this.$router.push({ path: `promocoes/editar-promocao/${id}` });
    },

    async limpaLocalStorage() {
      localStorage.removeItem("jornalzinho");
      localStorage.removeItem("selecionado");
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("data_inicial");
      localStorage.removeItem("data_final");
      localStorage.removeItem("image");
      localStorage.removeItem("have-push");
      localStorage.removeItem("show-text");
      localStorage.removeItem("promocaoSelecionada");
    },
  },
  async beforeMount() {
    await this.limpaLocalStorage();
    this.IsJornalzinho = true;
    await this.procurarPromocoes();
  },
};
</script>



